module.exports = __webpack_public_path__ + "img/FeaturedFloorPlans.3eb3a39e.png";